const reserveSite = () => import('@/views/main/reserve/site/site.vue')
export default {
  path: '/main/reserve/site',
  name: 'reserveSite',
  component: reserveSite,
  children: []
}
